import React from 'react';
import { Button } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import { useAuth } from '../../hooks/useAuth';

interface LoginButtonProps {
  className?: string;
}

const LoginButton: React.FC<LoginButtonProps> = ({ className }) => {
  const { login, isLoading } = useAuth();

  return (
    <Button
      type="primary"
      icon={<LoginOutlined />}
      onClick={login}
      loading={isLoading}
      className={className}
    >
      Войти
    </Button>
  );
};

export default LoginButton;

